export const REGISTER = {
  REQUIRED_MESSAGE: '필수 입력입니다',
  ID_MESSAGE: '영어로만 입력해주세요',
  PASSWORD_MESSAGE: '5자 이상 입력해주세요',
  NAME_MESSAGE: '20자 이하로 입력해주세요',
  PASSWORD_MIN_LENGTH: 5,
  NAME_MAX_LENGTH: 20,
};
